var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(_vm.$t('guestID.unknownOrder')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }